import React from 'react';
import '../../App.css';
import Form from '../Form';



function SignUp(){
    return(
        <div className="sign-up">
            {/* <h1 className="sign-up">SIGN UP</h1> */}
            <Form />
        </div>
    );

};

export default SignUp;